import { fetchOptions } from './csrf'

export const LINE_ITEMS = [
  'dealer_fees', 'down_payment', 'gap', 'payoff', 'price',
  'service', 'total', 'tradein', 'ttl_fees',
] as const

export const LINE_ITEM_LABELS: Record<string, string> = {
  dealer_fees: 'Dealer Fees',
  down_payment: 'Down Payment',
  gap: 'GAP',
  payoff: 'Payoff',
  price: 'Price',
  service: 'Service',
  total: 'Total',
  tradein: 'Trade-In',
  ttl_fees: 'TTL Fees',
}

export const ITEM_SUFFIXES = ['amnt', 'label', 'tax_1', 'tax_2', 'tax_credit', 'tax_apply_to', 'tax_credit_apply_to'] as const

export interface QuickDeskDisclaimer {
  id?: string
  title: string
  disclaimer_text: string
  _destroy?: boolean
}

export interface QuickDeskSetting {
  id: string | null
  expiration: number | null
  disclaimers: QuickDeskDisclaimer[]
  created_at: string | null
  updated_at: string | null
  [key: string]: unknown
}

interface QuickDeskSettingResponse {
  quick_desk_setting: QuickDeskSetting
}

interface ErrorResponse {
  errors: string[]
}

export const quickDeskSettingsApi = {
  async show(): Promise<QuickDeskSetting> {
    const response = await fetch('/api/v1/settings/quick-desk', fetchOptions())
    if (!response.ok) throw new Error('Failed to load Quick Desk settings')
    const data: QuickDeskSettingResponse = await response.json()
    return data.quick_desk_setting
  },

  async update(params: Record<string, unknown>): Promise<QuickDeskSetting> {
    const response = await fetch('/api/v1/settings/quick-desk', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ quick_desk_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: QuickDeskSettingResponse = await response.json()
    return data.quick_desk_setting
  },
}
